import React from 'react'
import { useState } from 'react'
import { MdClear } from 'react-icons/md'
import Api from '../../common/APIUtils'

export default function ModalDeleteSupplyItem({supplyItem, hideModal, onDeleted, onArchived}) {
    const api = new Api()
    const [phase, setPhase] = useState(() => { return "confirm" }) // confirm | working | blocked | archiving
    const [inlineError, setInlineError] = useState(() => { return "" })

    const isBusy = phase === "working" || phase === "archiving"

    const attemptDelete = () => {
        if (isBusy) return
        setInlineError("")
        setPhase("working")
        api.deleteSupplyItem(supplyItem._id)
        .then(() => {
            onDeleted()
        })
        .catch((err) => {
            if (err?.response?.status === 400) {
                setPhase("blocked")
                return
            }
            setPhase("confirm")
            setInlineError("Something went wrong. Try again in a moment.")
        })
    }

    const attemptArchive = () => {
        if (isBusy) return
        setInlineError("")
        setPhase("archiving")
        api.archiveSupplyItem(supplyItem._id)
        .then(() => {
            onArchived()
        })
        .catch(() => {
            setPhase("blocked")
            setInlineError("Something went wrong. Try again in a moment.")
        })
    }

    const isBlocked = phase === "blocked"
    const heading = isBlocked ? "⚠️ Can't Delete Item" : "⚠️ Delete Item"
    const bodyText = isBlocked
        ? `${supplyItem.supply_name} is still used by a recipe or batch, so it can't be deleted. You can archive it instead to hide it from your inventory while keeping those records intact.`
        : `Delete ${supplyItem.supply_name}?\n\nThis will remove it from your inventory. Items still used by a recipe or batch can't be deleted.`

    return (
        <div className="modal-boundary">
            <div className="modal-backdrop">
                <div className="modal-holder">
                    <div className="modal-overlay">

                        <div className="modal-header">
                            <h2>{heading}</h2>
                            <MdClear onClick={hideModal}/>
                        </div>

                        <div className="modal-display-text">{bodyText}</div>

                        {inlineError && <div className="modal-display-text" style={{color: "var(--ml-color-error)"}}>{inlineError}</div>}

                        <div className="modal-buttons" style={{gap: "14px"}}>
                            {!isBlocked &&
                            <span onClick={attemptDelete} style={isBusy ? {opacity: 0.6, pointerEvents: "none"} : {}}>
                                {phase === "working" ? "Deleting..." : "Delete item"}
                            </span>
                            }
                            {isBlocked &&
                            <span onClick={attemptArchive} style={isBusy ? {opacity: 0.6, pointerEvents: "none"} : {}}>
                                {phase === "archiving" ? "Archiving..." : "Archive instead"}
                            </span>
                            }
                            <span style={{backgroundColor: "grey"}} onClick={hideModal}>Cancel</span>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}
